import React from 'react';
import Input from '../Input';

import * as S from './styles';

export type SelectProps = {
  id: string;
  name?: string;
  placeholder: string;
  onChange: (e: React.FormEvent<HTMLInputElement>) => void;
  value: string;
  options: string[];
  error?: string;
};

const Select = ({ name, id, placeholder, onChange, value, options, error }: SelectProps) => {
  return (
    <S.Container>
      <Input name={name} list={id} placeholder={placeholder} onChange={onChange} value={value} error={error} />
      <datalist id={id}>
        {options.map((option, index) => (
          <option key={index} value={option} />
        ))}
      </datalist>
    </S.Container>
  );
};

export default Select;
